import { Navigate } from "react-router-dom";
import { useUser } from "../context/UserContext";
import { CircularProgress, Box } from "@mui/material";

/** Firebase session only — no email verification, username, or rep-setup gates. */
const AuthOnlyRoute = ({ children }) => {
  const { user, loadingUser } = useUser();

  if (loadingUser) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  return children;
};

export default AuthOnlyRoute;
